import React from "react";
import { useTranslation } from "react-i18next";
import {
  kidsDays,
  kidsLevels,
  kidsUpcomingLevels,
  formatTimeRange,
  sessionForDay,
} from "../../data/programs";

// Children's timetable. Schedule data lives in src/data/programs; the table is
// used from lg upwards and one card per level below it, so the page never
// scrolls sideways on a phone.
const KidsSchedule = () => {
  const { t } = useTranslation("home");

  return (
    <section className="kids-schedule section-padding" id="kids-programme">
      <div className="container">
        <div className="section-title">
          <h2>{t("kids.kicker")}</h2>
          <h3>{t("kids.title")}</h3>
        </div>

        {kidsUpcomingLevels.length > 0 && (
          <div className="kids-schedule__new-levels">
            {kidsUpcomingLevels.map((level) => (
              <span className="kids-schedule__new-level" key={level.id}>
                <span className="kids-schedule__new-flag">{t("kids.newFlag")}</span>
                {t(`kids.levels.${level.id}.title`)}
              </span>
            ))}
          </div>
        )}

        {/* Desktop: one row per level */}
        <div className="kids-schedule__table-wrap d-none d-lg-block">
          <table className="kids-schedule__table">
            <thead>
              <tr>
                <th scope="col">{t("kids.levelColumn")}</th>
                {kidsDays.map((day) => (
                  <th scope="col" key={day}>
                    {t(`days.${day}`)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {kidsLevels.map((level) => (
                <tr key={level.id}>
                  <th scope="row">
                    <span className="kids-schedule__level-title">
                      {t(`kids.levels.${level.id}.title`)}
                    </span>
                    <span className="kids-schedule__level-subtitle">
                      {t(`kids.levels.${level.id}.subtitle`)}
                    </span>
                    {level.noteKeys.length > 0 && (
                      <span className="kids-schedule__notes">
                        {level.noteKeys.map((note) => (
                          <span className="programme-badge" key={note}>
                            {t(`kids.notes.${note}`)}
                          </span>
                        ))}
                      </span>
                    )}
                  </th>
                  {kidsDays.map((day) => {
                    const session = sessionForDay(level.sessions, day);
                    return (
                      <td key={day}>
                        {session ? (
                          <span dir="ltr">{formatTimeRange(session)}</span>
                        ) : (
                          <span className="kids-schedule__empty">—</span>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile / tablet: one card per level */}
        <div className="row g-4 d-lg-none">
          {kidsLevels.map((level) => (
            <div className="col-md-6 col-12" key={level.id}>
              <div className="kids-schedule__card">
                <h4 className="kids-schedule__level-title">
                  {t(`kids.levels.${level.id}.title`)}
                </h4>
                <p className="kids-schedule__level-subtitle">
                  {t(`kids.levels.${level.id}.subtitle`)}
                </p>

                {level.noteKeys.length > 0 && (
                  <div className="kids-schedule__notes">
                    {level.noteKeys.map((note) => (
                      <span className="programme-badge" key={note}>
                        {t(`kids.notes.${note}`)}
                      </span>
                    ))}
                  </div>
                )}

                <ul className="kids-schedule__sessions">
                  {level.sessions.map((session, index) => (
                    <li key={`${level.id}-${session.day}-${index}`}>
                      <span className="kids-schedule__day">
                        {t(`days.${session.day}`)}
                      </span>
                      <span className="kids-schedule__time" dir="ltr">
                        {formatTimeRange(session)}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KidsSchedule;
